import { render, staticRenderFns } from "./UiCardSliderItem.vue?vue&type=template&id=64e96546"
import script from "./UiCardSliderItem.vue?vue&type=script&lang=js"
export * from "./UiCardSliderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports